<div class="email-viewer" [class.is-resizing]="isResizing" (click)="onViewerClick($event)">
  <div class="email-toolbar">
    <div class="email-toolbar__title">
      <app-dynamic-icon name="fa-solid fa-envelope" slot="icon-only"></app-dynamic-icon>
      <!-- <ion-icon name="mail-outline"></ion-icon> -->
      <span>{{ fileName || 'Email' }}</span>
    </div>
    <div class="email-toolbar__actions">
      <ion-button fill="clear" size="small" (click)="saveCurrentEmail()" [disabled]="!fileUrl && !sourceBlob">
        <app-dynamic-icon name="fa-solid fa-download" slot="icon-only"></app-dynamic-icon>
      </ion-button>
      <ion-button fill="clear" size="small" (click)="dismiss()">
        <app-dynamic-icon name="close" slot="icon-only"></app-dynamic-icon>
      </ion-button>
    </div>
  </div>

  @if (isLoading) {
    <div class="email-viewer__state">
      <ion-spinner name="crescent"></ion-spinner>
      <span>Loading email…</span>
    </div>
  } @else if (errorMessage) {
    <div class="email-viewer__state email-viewer__state--error">
      <ion-icon name="alert-circle-outline"></ion-icon>
      <span>{{ errorMessage }}</span>
    </div>
  } @else if (email) {
    <div class="email-meta">
      <div class="email-meta__subject">{{ email.subject }}</div>
      @if (email.from) {
        <div class="email-meta__row"><strong>From</strong><span>{{ email.from }}</span></div>
      }
      @if (email.to.length > 0) {
        <div class="email-meta__row"><strong>To</strong><span>{{ email.to.join(', ') }}</span></div>
      }
      @if (email.cc.length > 0) {
        <div class="email-meta__row"><strong>Cc</strong><span>{{ email.cc.join(', ') }}</span></div>
      }
      @if (email.bcc.length > 0) {
        <div class="email-meta__row"><strong>Bcc</strong><span>{{ email.bcc.join(', ') }}</span></div>
      }
      @if (email.sentAt) {
        <div class="email-meta__row"><strong>Date</strong><span>{{ email.sentAt }}</span></div>
      }
    </div>

    <div class="email-body">
      @if (email.html) {
        <div class="email-body__html" [innerHTML]="email.html"></div>
      } @else {
        <pre class="email-body__text">{{ email.text || '(empty message)' }}</pre>
      }
    </div>

    @if (email.attachments.length > 0) {
      <div class="email-attachments">
        <div class="email-attachments__title">Attachments</div>
        <div class="email-attachments__list">
          @for (attachment of email.attachments; track attachment.name + $index) {
            <button type="button" class="email-attachment" (click)="downloadAttachment(attachment)">
              <app-dynamic-icon name="fa-solid fa-paperclip" slot="icon-only"></app-dynamic-icon> 
              <!-- <ion-icon name="attach-outline"></ion-icon> -->
              <span>{{ attachment.name }}</span>
            </button>
          }
        </div>
      </div>
    }
  }

  <div class="resize-handle" (mousedown)="startResize($event)"></div>
</div>